import { MessageCircle, ArrowUpRight } from "lucide-react";
import { NAV_LINKS, SERVICES, LOGO, WHATSAPP_URL, WHATSAPP_DISPLAY, scrollToId } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="relative border-t border-slate-200 bg-white pt-16" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-10 pb-14 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5">
              <img src={LOGO} alt="Digital Advyzer logo" className="h-10 w-10 rounded-full object-cover ring-1 ring-slate-200" loading="lazy" />
              <span className="font-display text-lg font-bold tracking-tight text-[#111827]">Digital Advyzer</span>
            </div>
            <p className="mt-4 font-display text-sm font-semibold text-slate-500">
              Websites. AI Ads. Automations.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">Navigation</h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button onClick={() => scrollToId(l.id)} className="text-sm text-slate-600 transition-colors hover:text-[#111827]" data-testid={`footer-nav-${l.id}`}>
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">Services</h4>
            <ul className="mt-4 space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <button onClick={() => scrollToId("services")} className="text-sm text-slate-600 transition-colors hover:text-[#111827]" data-testid={`footer-service-${s.id}`}>
                    {s.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">Contact</h4>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 rounded-full bg-emerald-50 px-4 py-2.5 text-sm font-semibold text-emerald-600 ring-1 ring-emerald-100 transition-colors hover:bg-emerald-100" data-testid="footer-whatsapp">
              <MessageCircle className="h-4 w-4" />
              WhatsApp: {WHATSAPP_DISPLAY}
            </a>
            <button onClick={() => scrollToId("contact")} className="mt-3 flex items-center gap-1 text-sm text-slate-600 transition-colors hover:text-[#111827]" data-testid="footer-start-project">
              Start a project <ArrowUpRight className="h-3.5 w-3.5" />
            </button>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-slate-200 py-7 sm:flex-row">
          <p className="text-xs text-slate-500">© 2026 Digital Advyzer. All rights reserved.</p>
          <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-400">Build · Automate · Advertise</p>
        </div>
      </div>
    </footer>
  );
}
